<template>
  <div id="app">
  <!--  <div class="main">-->
  <router-view/>
    <Loading v-show="LOADING"></Loading>
    <!--  </div>-->
  </div>
</template>
<script>
   //import Login from "@/components/login/login"
   import {mapState} from 'vuex'
   import Loading from '@/components/loading'
  export default {
    name: "App",
     components: {
       //Login
       Loading
     },
    computed:{
      ...mapState(['LOADING'])
    },
    data() {
      return {
        path: ''
      }
    },
    mounted() {
      this.path = this.$route.path;
      window.onload = function () {
        let lastTouchEnd = 0;
        document.addEventListener('touchstart', function (event) {
          if (event.touches.length > 1) {
            event.preventDefault();
          }
        });
        document.addEventListener('touchend', function (event) {
          let now = (new Date()).getTime();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        }, false);
        document.addEventListener('gesturestart', function (event) {
          event.preventDefault();
        });
        document.addEventListener('dblclick', function (event) {
          event.preventDefault();
        })
      }
    },
    watch: {
      $route(to, from) {
        this.path = to.path
      }
    }
  }

</script>
